module.exports = __webpack_public_path__ + "img/Online_collaboration.be113dd5.svg";